import React from 'react';
import ReactDOM from 'react-dom';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import classNames from 'classnames';
import { trackEvent } from 'dibs-tracking';
import mobileCheck from 'bunsen/helpers/mobileCheck';
import forceFavorite from '../../../favorites/forceFavorite.es';
import { SAVE_ITEM_FLOW } from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
import userHelper from '../../../global/core/commonjs/userHelper';
import {
    CALLOUT_TYPE_SAVE_ITEM,
    CALLOUT_TYPE_SAME_PDP,
} from '../../../components/Callout/calloutHelper.es';

import HeartComponent from 'dibs-portfolio-heart';
import Callout from '../../../components/Callout/Callout';

import styles from './PdpFavoriteItem-style.scss';
import calloutCopy from './PdpFavoriteItemCallout.json';

class PdpFavoriteItem extends React.Component {
    constructor(props) {
        super(props);

        this.alreadyForced = false;
        this.authModalShow = this.authModalShow.bind(this);
        this.onFavorited = this.onFavorited.bind(this);
        this.onUnFavorited = this.onUnFavorited.bind(this);
        this.onForceFavoriteItem = this.onForceFavoriteItem.bind(this);
    }

    componentDidMount() {
        if (this.props.viewer) {
            this.forceFavorite();
            this.alreadyForced = true;
        }
    }

    componentDidUpdate() {
        if (!this.alreadyForced && this.props.viewer) {
            this.forceFavorite();
            this.alreadyForced = true;
        }
    }

    authModalShow(favoriteItem) {
        userHelper
            .checkLogin(
                {
                    label: 'save item - product page',
                },
                SAVE_ITEM_FLOW,
                false,
                { item: this.props.item }
            )
            .then(favoriteItem);
    }

    onFavorited() {
        if (!this.props.forceFavoriteItem) {
            this.trackFavoriting('item added');
        }

        if (this.props.onFavorited) {
            this.props.onFavorited();
        }
    }

    onUnFavorited() {
        this.trackFavoriting('item removed');
    }

    trackFavoriting(action) {
        trackEvent({
            action,
            label: 'PDP',
            category: 'item favoriting',
        });
    }

    forceFavorite() {
        const el = ReactDOM.findDOMNode(this);
        const { portfolioItemMatches } = this.props.viewer;

        forceFavorite.init({
            type: forceFavorite.TYPE_ITEM,
            isFavorited: !!portfolioItemMatches && !!portfolioItemMatches.length,
            heartEl: el.getElementsByClassName('js-heart-component')[0],
        });
    }

    onForceFavoriteItem(addToHeart) {
        const { viewer, userId } = this.props;
        addToHeart({ portfolioId: get(viewer, 'userPortfolios.edges[0].node.serviceId'), userId });
    }

    render() {
        const {
            showCircle,
            viewer,
            callout,
            lastCallout,
            forceFavoriteItem,
            ...params
        } = this.props;
        const className = classNames(styles.pdpHeartItem, {
            [styles.withCircle]: showCircle,
        });

        return (
            <div className={className}>
                <div className={styles.heartComponentWrapper} data-tn="item-save-to-portfolio">
                    <HeartComponent
                        className="js-heart-component"
                        type="pdp"
                        viewer={viewer}
                        {...params}
                        // handlers
                        authModalShow={this.authModalShow}
                        onFavorited={this.onFavorited}
                        onUnFavorited={this.onUnFavorited}
                        forceFavoriteItem={forceFavoriteItem}
                        onHeartClick={this.onForceFavoriteItem}
                    />
                </div>

                {/* SaveItem callout */}
                {!mobileCheck.any() &&
                !showCircle &&
                (lastCallout === CALLOUT_TYPE_SAVE_ITEM ||
                    lastCallout === CALLOUT_TYPE_SAME_PDP) ? (
                    <Callout callout={callout} copy={calloutCopy[lastCallout]} type={lastCallout} />
                ) : null}
            </div>
        );
    }
}

PdpFavoriteItem.propTypes = {
    showCircle: PropTypes.bool,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    viewer: PropTypes.object,
    callout: PropTypes.object,
    lastCallout: PropTypes.string,
    item: PropTypes.object,
    forceFavoriteItem: PropTypes.bool,
    onFavorited: PropTypes.func,
};

export default Relay.createContainer(PdpFavoriteItem, {
    initialVariables: {
        loadPortfolioData: false,
        selectedItemIds: [],
        userId: null,
        userIds: [],
    },
    fragments: {
        viewer: ({ loadPortfolioData, selectedItemIds, userId, userIds }) => Relay.QL`
                fragment on Viewer {
                    ${HeartComponent.getFragment('viewer', {
                        loadPortfolioData,
                        selectedItemIds,
                        userId,
                        userIds,
                    })}
                    portfolioItemMatches(userIds: $userIds, itemIds: $selectedItemIds, portfolioTypes: [HEART]) @include(if: $loadPortfolioData) {
                        portfolioId
                    }
                    userPortfolios: portfolios(first: 1, portfolioTypes: [HEART], userIds: $userIds) @include(if: $loadPortfolioData) {
                        edges {
                            node {
                                serviceId
                            }
                        }
                    }
                }
            `,
        item: () => Relay.QL`
                fragment on Item {
                    title
                    firstPhotoWebPath(size: thumb)
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Favorites/PdpFavoriteItem.jsx